import { RoutesService, eLayoutType } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const PARTNER_LEADS_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/partner-leads',
        name: '::Menu:PartnerLeads',
        iconClass: 'fas fa-handshake',
        // Next to Referrers: the requests sent in from the landing site's /partners form.
        parentName: '::Menu:UserManagement',
        layout: eLayoutType.application,
        requiredPolicy: 'ReturnLy.PartnerLeads',
        order: 5,
      },
    ]);
  };
}
